import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { IService, IChurch } from './providers/interfaces';

@Pipe({
  name: 'filterByChurch'
})
export class FilterByChurchPipe implements PipeTransform {
  transform( values: IService[], church?: IChurch ): any {
    return _.filter( values, value => value.churchId === church.id );
  }
}



// WEBPACK FOOTER //
// ./src/app/filter-by-church.pipe.ts